import type { Environment } from '@change-corgi/core/environment';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useChatAgentSubmit } from '../useChatAgentSubmit';

type UseChatAgentReturn = ModelHookResult<
	{ iframeSrc: string; loading: boolean },
	{ onSubmit: ReturnType<typeof useChatAgentSubmit>['actions']['onSubmit'] }
>;

/** Currently, only production vs. non-production matters for the chat agent's own deployment. */
function getChildOrigin(environment: Environment): string {
	if (environment === 'development') return 'https://petition-chat.localhost';

	// TODO: replace with the real petition-chat origin(s) once available.
	if (environment === 'production') return 'https://petition-chat.change.org';
	return 'https://petition-chat.staging-change.org';
}

export function useChatAgent(): UseChatAgentReturn {
	const { environment } = useUtilityContext();
	const childOrigin = getChildOrigin(environment.getEnvironment());

	// TODO: map additional params for the chat agent, so that the agent can be preloaded with data
	// initial: issue prompt
	// env: current non-prod environment (no env = production)
	const iframeSrc = `${childOrigin}/chat`;

	const { data: submitData, actions: submitActions } = useChatAgentSubmit();

	return {
		data: { iframeSrc, loading: submitData.loading },
		actions: { onSubmit: submitActions.onSubmit },
	};
}
